import { useState } from 'react';

export const useCurrencyClaims = (currencies, initialClaims = {}) => {
  const [usedCurrencies, setUsedCurrencies] = useState(initialClaims);

  const getCurrencies = owner => {
    const unavailableCurrencies = Object.values(usedCurrencies);
    const isUnusedCurrency = key => !unavailableCurrencies.includes(key);

    if (owner) {
      return currencies.filter(
        entry => entry.key === usedCurrencies[owner] || isUnusedCurrency(entry.key),
      );
    } else {
      return currencies.filter(entry => isUnusedCurrency(entry.key));
    }
  };

  const claimCurrency = (currency, owner) =>
    setUsedCurrencies(prev => ({
      ...prev,
      [owner]: currency,
    }));

  const releaseClaim = owner => {
    setUsedCurrencies(prev => {
      const { [owner]: toRemove, ...toKeep } = prev;
      return toKeep;
    });
  };

  return {
    getCurrencies,
    claimCurrency,
    releaseClaim,
  };
};
